/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InsurancePayor } from './InsurancePayor';
import {
    InsurancePayorFromJSON,
    InsurancePayorFromJSONTyped,
    InsurancePayorToJSON,
} from './InsurancePayor';
import type { PalAuthPlatform } from './PalAuthPlatform';
import {
    PalAuthPlatformFromJSON,
    PalAuthPlatformFromJSONTyped,
    PalAuthPlatformToJSON,
} from './PalAuthPlatform';

/**
 * 
 * @export
 * @interface PalAuthPlatformPayorForm
 */
export interface PalAuthPlatformPayorForm {
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformPayorForm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformPayorForm
     */
    payor_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformPayorForm
     */
    auth_platform_id?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PalAuthPlatformPayorForm
     */
    submission_form?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatformPayorForm
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PalAuthPlatformPayorForm
     */
    version?: number;
    /**
     * 
     * @type {InsurancePayor}
     * @memberof PalAuthPlatformPayorForm
     */
    payor?: InsurancePayor;
    /**
     * 
     * @type {PalAuthPlatform}
     * @memberof PalAuthPlatformPayorForm
     */
    auth_platform?: PalAuthPlatform;
}

/**
 * Check if a given object implements the PalAuthPlatformPayorForm interface.
 */
export function instanceOfPalAuthPlatformPayorForm(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthPlatformPayorFormFromJSON(json: any): PalAuthPlatformPayorForm {
    return PalAuthPlatformPayorFormFromJSONTyped(json, false);
}

export function PalAuthPlatformPayorFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthPlatformPayorForm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'payor_id': !exists(json, 'payor_id') ? undefined : json['payor_id'],
        'auth_platform_id': !exists(json, 'auth_platform_id') ? undefined : json['auth_platform_id'],
        'submission_form': !exists(json, 'submission_form') ? undefined : json['submission_form'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'payor': !exists(json, 'payor') ? undefined : InsurancePayorFromJSON(json['payor']),
        'auth_platform': !exists(json, 'auth_platform') ? undefined : PalAuthPlatformFromJSON(json['auth_platform']),
    };
}

export function PalAuthPlatformPayorFormToJSON(value?: PalAuthPlatformPayorForm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'payor_id': value.payor_id,
        'auth_platform_id': value.auth_platform_id,
        'submission_form': value.submission_form,
        'description': value.description,
        'version': value.version,
        'payor': InsurancePayorToJSON(value.payor),
        'auth_platform': PalAuthPlatformToJSON(value.auth_platform),
    };
}

